<template>
  <div class="tender">
    <header>
      <div class="navbar-fixed">
      <nav>
        <div class="nav-wrapper">
          <div class="row">
            <div class="col s12">
              <a href="#" data-target="sidenav-1" class="left sidenav-trigger hide-on-medium-and-up" style="z-index:100;">
                <i class="material-icons">menu</i>
              </a>
              <h5 class="headerTitle desktopHeader">Assam Power Distribution Company Limited</h5>
              <h5 class="mobileHeader">Assam Power Distribution Company Limited</h5>
            </div>
          </div>
        </div>
      </nav>
    </div>
    </header>

    <!-- <ul id="sidenav-1" class="sidenav sidenav-fixed">
      <li class="sidenav-header" style="background-color:#01579b;">
          <div class="row">
            <div class="col s12">
                <h6 style="color:white;">Welcome Admin</h6>
            </div>
          </div>
        </li>
      <li><router-link class="waves-effect textAlign" to="/contact">
        <i class="material-icons iconShift">contact_phone</i>Contact</router-link></li>
      <li  class="active"><router-link class="waves-effect textAlign" to="/tender">
        <i class="material-icons iconShift">assignment</i>Tender</router-link></li>
      <li><router-link class="waves-effect textAlign" to="/news">
        <i class="material-icons iconShift">speaker_notes</i>News</router-link></li>
      <li><router-link class="waves-effect textAlign" to="/career">
        <i class="material-icons iconShift">portrait</i>Career</router-link></li>
    </ul> -->
    <div class="row positioning">
      <span class="fontstyle">Enter Tender Details</span>
    </div>
    <div class="divider" style="margin-top: -19px;"></div>
    <ul id="sidenav-1" class="sidenav sidenav-fixed">
      <li><div class="user-view">
         <div class="background sideGradient">
         </div>
         <div class="row" style="padding-bottom:20px;">
           <div class="col m2">
             <img class="circle" src="../assets/adminperson4.png" style="width:80px; height:80px; margin-top: -26px;">
           </div>
           <div class="col m6 offset-m2">
               <a class="dropdown-trigger btn btntransparent" href='#' data-target='dropdown1'><i class="material-icons right" style="margin-left: -20px;">arrow_drop_down</i>Admin</a>
               <ul id='dropdown1' class='dropdown-content' style="">
                <li><a href="#!"><span>Logout</span></a></li>
                <li><a href="#!">Change Password</a></li>
              </ul>
           </div>
         </div>
       </div></li>
      <li style="margin-top: -20px;"><router-link class="waves-effect textAlign" to="/updatecontact">
        <i class="material-icons iconShift">contact_phone</i>Update Contact</router-link></li>
      <li>
        <ul class="collapsible">
          <li class="active">
            <div class="collapsible-header" @click="arrowShowHide('arrowDown','arrowUp')">
              <router-link class="" to="" style="margin-left: 1rem; display:flex;">
                <i class="material-icons iconShift" style="color: rgba(0,0,0,0.54);">assignment</i>
                <span style="color: black">Tender</span>
                <i class="material-icons iconShift" id="arrowDown" style="color:#C850C0; margin-left: -2rem !important; display: none;">arrow_drop_down</i>
                <i class="material-icons iconShift" id="arrowUp" style="color:#C850C0; margin-left: -2rem !important; ">arrow_drop_up</i>
              </router-link>
            </div>
            <div class="collapsible-body">
              <li class="active"><router-link to="/newtender"><i class="material-icons" style="color:#C850C0; margin-left:3rem; font-size:16px;">edit</i>
                <span style="margin-left:-6rem; font-size: 12px;">Create Tender</span></router-link></li>
                <li><router-link to="/publishtender"><i class="material-icons" style="color:#C850C0; margin-left:3rem; font-size:16px;">event_available</i>
                  <span style="margin-left:-4.2rem; font-size: 12px;">Upload Documents</span></router-link></li>
                  <li><router-link to="/deletetenderdocument"><i class="material-icons" style="color:#C850C0; margin-left:3rem; font-size:16px;">event_available</i>
                    <span style="margin-left:-4.2rem; font-size: 12px;">Delete Documents</span></router-link></li>
            </div>
          </li>
        </ul>
      </li>
      <li><router-link class="waves-effect textAlign" to="/news">
        <i class="material-icons iconShift">speaker_notes</i>News</router-link></li>
      <li><router-link class="waves-effect textAlign" to="/career">
        <i class="material-icons iconShift">portrait</i>Career</router-link></li>

        <div class="footer-fixed">
          <footer class="footerstyle">
            <div class="footer-copyright">
              <div class="container" style="font-size:11px; text-align:center;">
              © 2020 Copyright Assam Power Distribution Company Limited, Developed by IT Cell, APDCL.
              </div>
            </div>
          </footer>
        </div>
    </ul>

    <main>
      <!-- succes modal -->
      <div id="successModal" class="modal" >
        <div class="modal-content" style="background-color:#e8f5e9  ;">
          <h4>Create New Tender</h4>
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
            <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
            <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
          </svg>
          <p class="success">Successfully Created !</p>
        </div>
        <div class="modal-footer" style="margin-top: -7rem; background-color:#e8f5e9  ;">
          <a href="#!" class="modal-close waves-effect waves-green btn green">OK</a>
        </div>
      </div>
      <!-- error modal -->
      <div id="errorModal" class="modal">
        <div class="modal-content"  style="background-color:#ffebee;">
          <h4>Create New Tender</h4>
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
            <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
            <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
            <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
          </svg>
          <p class="error">Tender Creation Failed !</p>
        </div>
        <div class="modal-footer" style="margin-top: -7rem; background-color:#ffebee;">
          <a href="#!" class="modal-close waves-effect waves-red btn red">OK</a>
        </div>
      </div>
      <form id="form-add-tender">
        <div class="row">
          <div class="col s12 m2 l2 xl2 paddingTop left">
            <h6>Description: </h6>
            <!-- <datepicker></datepicker> -->
          </div>
          <div class="input-field col s12 m3 l3 xl3">
            <textarea id="description" class="materialize-textarea validate" data-length="200" placeholder="Enter the tender description"></textarea>
          </div>
          <div class="col s12 m2 l2 xl2 offset-m1 offset-l1 offset-xl1 paddingTop left">
            <h6>Tender Number: </h6>
          </div>
          <div class="input-field col s12 m3 l3 xl3">
            <input id="tenderNo" type="text" class="validate" placeholder="Enter the tender number">
          </div>
        </div>
        <!-- New Row -->
        <div class="row">
          <div class="col s12 m2 l2 xl2 paddingTop left">
            <h6>Tender Date: </h6>
          </div>
          <div class="input-field col s12 m3 l3 xl3">
            <!-- <input id="tenderDate" type="text" class="datepicker validate" placeholder="Enter tender date"> -->
            <datepicker id="tenderDate" format="MM/dd/yyyy" style="color:#424242;" placeholder="Enter tender date"></datepicker>
          </div>
          <div class="col s12 m2 l2 xl2 offset-m1 offset-l1 offset-xl1 paddingTop left">
            <h6>Pre-Bid Meeting Date: </h6>
          </div>
          <div class="input-field col s12 m3 l3 xl3">
            <!-- <input id="bidStartDate" type="text" class="datepicker validate" placeholder="Enter bid start date"> -->
            <datepicker id="preBidDate" format="MM/dd/yyyy" style="color:#424242;" placeholder="Enter pre bid date"></datepicker>
          </div>
        </div>
        <!-- New Row -->
        <div class="row">
          <div class="col s12 m2 l2 xl2 paddingTop left">
            <h6>Bid Start Date: </h6>
          </div>
          <div class="input-field col s12 m3 l3 xl3">
            <!-- <input id="bidEndDate" type="text" class="datepicker validate" placeholder="Enter bid end date"> -->
            <datepicker id="bidStartDate" format="MM/dd/yyyy" style="color:#424242;" placeholder="Enter bid start date"></datepicker>
          </div>
          <div class="col s12 m2 l2 xl2 offset-m1 offset-l1 offset-xl1 paddingTop left">
            <h6>Bid End Date: </h6>
          </div>
          <div class="input-field col s12 m3 l3 xl3">
            <!-- <input id="bidOpenDate" type="text" class="datepicker validate" placeholder="Enter bid open date"> -->
            <datepicker id="bidEndDate" format="MM/dd/yyyy" style="color:#424242;" placeholder="Enter bid end date"></datepicker>
          </div>
        </div>
        <!-- New Row -->
        <div class="row">
          <div class="col s12 m2 l2 xl2 paddingTop left">
            <h6>Bid Opening Date: </h6>
          </div>
          <div class="input-field col s12 m3 l3 xl3">
            <!-- <input id="bidEndDate" type="text" class="datepicker validate" placeholder="Enter bid end date"> -->
            <datepicker id="bidOpeningDate" format="MM/dd/yyyy" style="color:#424242;" placeholder="Enter bid opening date"></datepicker>
          </div>
          <div class="col s12 m2 l2 xl2 offset-m1 offset-xl1 paddingTop left">
            <h6>Upload File: </h6>
          </div>
          <div class="col s12 m3 l3 xl3 input-field tenderFile">

            <div >
              <input id="uploadFile" type="file" class=" browser-default" placeholder="Upload tender file" >
            </div>
          </div>
        </div>
        <!-- New Row -->
        <div class="row">
          <div class="col s3 m3 l3 xl3 offset-s2 offset-m3 offset-l3 offset-xl3">
            <button class="btn" style="background-color: #43a047;" type="submit" @click="addTender($event)" name="actionSubmit">SUBMIT
              <i class="material-icons right">send</i>
            </button>
          </div>
          <div class="col s3 m3 l3 xl3 offset-s1">
            <button class="btn" style="background-color: #ff9800;" type="submit" name="actionReset">Reset
              <i class="material-icons right">loop</i>
            </button>
          </div>
        </div>
      </form>
    </main>
  </div>
</template>
<script>
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';

import 'materialize-css/dist/css/materialize.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import M from 'materialize-css';
//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://apdclrms.com/website";
const urlCommon = "https://www.apdcl.org/website";

export default{
  methods:{
    arrowShowHide(x,y){
       var d = document.getElementById(x);
       var u = document.getElementById(y);
       if (d.style.display === "none") {
         d.style.display = "block";
         u.style.display = "none";
       } else {
         d.style.display = "none";
         u.style.display = "block";
       }
    },
    addTender(event){
      event.stopPropagation()
      event.preventDefault()

      let formData = new FormData();
      formData.append('file', document.getElementById("uploadFile").files[0]);
      formData.append('description', document.getElementById("description").value);
      formData.append('tender_no', document.getElementById("tenderNo").value);
      formData.append('tender_date', document.getElementById("tenderDate").value);
      formData.append('prebid_date', document.getElementById("preBidDate").value);
      formData.append('bid_start_date', document.getElementById("bidStartDate").value);
      formData.append('bid_end_date', document.getElementById("bidEndDate").value);
      formData.append('bid_opening_date', document.getElementById("bidOpeningDate").value);

      axios.post(urlCommon + "/api/admin/createtender", formData,  {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function(response) {
        console.log(response)

        if (response.data == "success") {
          document.getElementById("form-add-tender").reset()
          var elems = document.getElementById('successModal');
          var instance = M.Modal.init(elems);
          instance.open();
        } else {
          document.getElementById("form-add-tender").reset()
          var elems = document.getElementById('errorModal');
          var instance = M.Modal.init(elems);
          instance.open();
        }
      })


    }
  },
  mounted(){
  
      M.AutoInit();

    var elems = document.querySelectorAll('.sidenav');
    var instances = M.Sidenav.init(elems, {});
    var drops = document.querySelectorAll('.dropdown-trigger');
    var instances = M.Dropdown.init(drops, {});
    var collaps = document.querySelectorAll('.collapsible');
    var instances = M.Collapsible.init(collaps, {});
  },
  components:{
    Datepicker
  }
}
</script>
<style>
.modal{
  overflow-y:hidden !important;
}

  /* header, footer {
    padding-left: 300px;
  } */
  main{
    padding-left: 350px;
  }
  .sideGradient{
    background-color: #4158D0;
    background-image: linear-gradient(43deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%);
  }
  .headerTitle{
    padding-left: 250px;
  }
  .mobileHeader{
    display: none;
    text-align: left;
  }
  .desktopHeader{
    display:block;
  }

  .positioning{
    margin-top: 10px;
    margin-left: 24rem;
    text-align: left;
  }

  .fontstyle{
    font-size: 20px;
    color:#006064;
  }

  .sidenav-header {
    /* background: url("../images/user-bg.jpg") no-repeat center center; */
    background-size: cover;
    margin-bottom: 0px;
    padding: 18px 0 0 18px;
    height: 64px;
      .row {
        margin-bottom: 0;
      }
    }

    .btntransparent{
      background-color: Transparent;
      background-repeat:no-repeat;
      border: none;
      cursor:pointer;
      overflow: hidden;
      outline:none;
      box-shadow: none!important;
      width:9rem;
      margin-left: -30px;
      background-color: unset !important;
      color: white !important;
    }

    /* .btntransparent:hover{
      background-color: unset !important;
      color: unset !important;
    } */

    .nav-wrapper{
      background-color: #2c5680 ;
    }

    .paddingTop{
      padding-top: 1.5rem !important;
    }

    .dropdown-content{
      width: 180px !important;
      overflow-y: hidden;
    }

    input[type=text]{
      color:black !important;
      border-bottom: 1px solid #9e9e9e !important;
    }

    .textAlign{
      text-align: left;
    }

    .tenderFile{
      margin-top: 2rem;
    }

    .iconShift{
      margin:0px !important;
      padding: 0px 42px !important;
    }

    .left{
      text-align: left;
    }
    .footerstyle{
      position: absolute;
      top: calc(100vh - 57px);
    }
    svg {
      width: 100px;
      display: block;
      margin: 40px auto 0;
    }
    .path {
      stroke-dasharray: 1000;
      stroke-dashoffset: 0;
    }
    .path.circle {
      -webkit-animation: dash 0.9s ease-in-out;
      animation: dash 0.9s ease-in-out;
    }
    .path.line {
      stroke-dashoffset: 1000;
      -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
      animation: dash 0.9s 0.35s ease-in-out forwards;
    }
    .path.check {
      stroke-dashoffset: -100;
      -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
      animation: dash-check 0.9s 0.35s ease-in-out forwards;
    }
    p {
      text-align: center;
      margin: 20px 0 60px;
      font-size: 1.25em;
    }
    p.success {
      color: #73AF55;
    }
    p.error {
      color: #D06079;
    }
    @-webkit-keyframes dash {
      0% {
        stroke-dashoffset: 1000;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
    @keyframes dash {
      0% {
        stroke-dashoffset: 1000;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
    @-webkit-keyframes dash-check {
      0% {
        stroke-dashoffset: -100;
      }
      100% {
        stroke-dashoffset: 900;
      }
    }
    @keyframes dash-check {
      0% {
        stroke-dashoffset: -100;
      }
      100% {
        stroke-dashoffset: 900;
      }
    }


  @media only screen and (max-width : 992px) {
    header, main, footer {
      padding-left: 0 !important;
    }
    .headerTitle{
      padding-left: 0;
    }
    .mobileHeader{
      display: block;
      font-size: 18px;
      text-align: center;
    }
    .desktopHeader{
      display:none;
    }
    .paddingTop{
      padding-top: 0 !important;
    }
    .positioning{
      margin-left: 10px !important;
    }
    .fontstyle{
      font-size: 15px;
    }
    .footerstyle{
      position: absolute;
      top: calc(100vh - 67px);
    }
    .tenderFile{
      margin-top: 10px;;
    }
  }
</style>
